// keyed by the lead channel `brand` values in Contentful
export const osanoScriptUrlByBrand: Record<string, string> = {
  AUTOPAY:
    'https://cmp.osano.com/Azq8b9SazCgbg131e/efb3a723-eaec-436a-b10d-446adaa79eff/osano.js',
  RateGenius:
    'https://cmp.osano.com/Azq8b9SazCgbg131e/ad9ebdf4-68d7-4291-8223-437702837afa/osano.js',
  Tresl:
    'https://cmp.osano.com/Azq8b9SazCgbg131e/bb0b3db1-88b0-4b9e-b970-4156507051bd/osano.js',
};
